import React, { useState } from "react";
import { useHistory } from "react-router";
//data
import { useData } from "../../../components/firebase/DataProvider";
//component
import Header from "../../../components/molecules/Header";
import Gap from "../../../components/atoms/Gap";
import ListItemMap from "../PencairanSaya/listItem";
// material
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import useStyles from "./style";
//utils
import currency from "./../../../utils/currency";
import DialogPw from "./dialogPw";

function PencairanSaya() {
  const classes = useStyles();
  const history = useHistory();
  const { pencairan, kredit } = useData();
  const total_pencairan_approved = kredit?.total_pencairan_approved ?? 0;
  const total_pencairan_pending = kredit?.total_pencairan_pending ?? 0;
  const [dialog, setDialog] = useState({
    open: false,
  });

  const totalPencairan = pencairan
    ?.filter?.((p) => p.status !== "rejected")
    ?.reduce?.((prev, curr) => {
      return prev + (curr.total_pencairan ?? 0);
    }, 0);

  return (
    <>
      <Header
        type="with-title"
        title="Pencairan Saya"
        onClick={() => history.goBack()}
      />
      <div
        className={classes.hero}
        style={{
          backgroundColor: "#F5F5F5",
        }}
      >
        <Gap height={20} />
        <div className={classes.wrapHeader}>
          <Typography className={classes.liquidSecond}>
            Total Pencairan Saya
          </Typography>
          <Typography className={classes.liquidTitle}>
            {currency(totalPencairan)}
          </Typography>
        </div>
        <div className={classes.wrapCard}>
          <Card>
            <CardContent>
              <Grid container justify="space-evenly">
                <Grid item className={classes.wrapGrid}>
                  <Typography className={classes.liquidPrimary}>
                    Total Berhasil
                  </Typography>
                  <Typography className={classes.liquidSecond}>
                    {currency(total_pencairan_approved)}
                  </Typography>
                </Grid>
                <Grid item className={classes.wrapGrid}>
                  <Typography className={classes.liquidPrimary}>
                    Total Pending
                  </Typography>
                  <Typography className={classes.liquidSecond}>
                    {currency(total_pencairan_pending)}
                  </Typography>
                </Grid>
              </Grid>
              <Gap height={10} />
              <Divider style={{ marginLeft: -15, marginRight: -15 }} />
              <Gap height={10} />
              {/* <div className={classes.wrapBtnList}> */}
              <CardActions>
                <Button
                  variant="contained"
                  size="small"
                  fullWidth
                  color="primary"
                  onClick={(e) => {
                    setDialog({ open: true });
                  }}
                >
                  Ajukan Pencairain
                </Button>
              </CardActions>
              {/* </div> */}
            </CardContent>
            <DialogPw
              dialog={dialog}
              handleClose={() => {
                setDialog({ open: false });
              }}
            />
          </Card>
        </div>
      </div>
      <div className={classes.wrapList}>
        <List
          subheader={
            <ListSubheader disableSticky={true}>
              Riwayat Pencairan
            </ListSubheader>
          }
        >
          {pencairan.length > 0 ? (
            pencairan
              .sort((a, b) => {
                return b.created_at?.toMillis?.() - a.created_at?.toMillis?.();
              })
              .map((item, index) => {
                return <ListItemMap key={index} data={item} />;
              })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                marginTop: "2.5%",
              }}
            >
              <Typography className={classes.liquidPrimary}>
                Tidak Ada data
              </Typography>
            </div>
          )}
        </List>
      </div>
    </>
  );
}

export default PencairanSaya;
